import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_tag = _resolveComponent("joy-tag")!
  const _component_joy_tags_list = _resolveComponent("joy-tags-list")!

  return (_openBlock(), _createBlock(_component_joy_tags_list, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
        return (_openBlock(), _createBlock(_component_joy_tag, {
          key: tag.name,
          variant: "primary",
          class: "tags",
          removable: "",
          onJoyTagRemove: _ctx.handlerRemove
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(tag.name), 1)
          ]),
          _: 2
        }, 1032, ["onJoyTagRemove"]))
      }), 128))
    ]),
    _: 1
  }))
}